import { Typography } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import Close from '@material-ui/icons/Close';
import React from 'react';
import styles from './StyledPrompt.module.scss';

export function StyledPrompt(props: {
    open: boolean;
    title?: string;
    allowOverFlow?: boolean;
    actions: React.ReactNode;
    children?: React.ReactNode;
    onCancel?(): void;
}) {
    const { allowOverFlow, ...otherProps } = props;

    return (
        <Dialog
            {...otherProps}
            onClick={(e: React.MouseEvent) => e.stopPropagation()}
            onClose={props.onCancel}
            disableBackdropClick
            maxWidth='sm'
            classes={{
                paperScrollPaper: allowOverFlow ? styles.allowOverflow : '',
                paperWidthSm: styles.smallWidth
            }}
        >
            {props.title && (
                <DialogTitle disableTypography>
                    <Typography variant='h6' className={styles.title}>
                        {props.title}
                    </Typography>
                </DialogTitle>
            )}
            {props.onCancel && (
                <IconButton title='Close' className={styles.closeButton} onClick={props.onCancel}>
                    <Close />
                </IconButton>
            )}
            <DialogContent
                classes={{
                    root: props.allowOverFlow ? styles.allowOverflow : ''
                }}
            >
                {props.children}
            </DialogContent>
            <DialogActions
                classes={{
                    root: styles.dialogActions
                }}
            >
                {props.actions}
            </DialogActions>
        </Dialog>
    );
}
